module.exports = __webpack_public_path__ + "static/media/IMAS.2c25f8a5.mp4";